import React from "react";
import { Link } from "react-router-dom";
import "./LandingPage.css";

const features = [
  { icon: "⌁", title: "See the whole portfolio", text: "Track positions, allocation and performance in one calm, focused workspace." },
  { icon: "◇", title: "Research with context", text: "Move from a ticker to fundamentals, charts and the story behind the numbers." },
  { icon: "↗", title: "Test before you invest", text: "Build rules visually and backtest an idea across years of market history." }
];

const tickerTape = ["AAPL  +1.24%", "MSFT  +0.81%", "NVDA  +2.43%", "AMZN  +0.56%", "META  +1.08%"];

export default function LandingPage() {
  return (
    <main className="landing">
      <div className="landingGlow landingGlowOne" />
      <div className="landingGlow landingGlowTwo" />

      <section className="landingHero">
        <div className="landingEyebrow"><span /> Portfolio intelligence, simplified</div>
        <h1>Invest with a clearer<br /><em>point of view.</em></h1>
        <p className="landingLead">StockSleuth brings portfolio tracking, company research, screening and strategy testing together—so every decision starts with evidence.</p>
        <div className="landingActions">
          <Link className="landingPrimary" to="/SignUp">Start exploring <span>→</span></Link>
          <Link className="landingSecondary" to="/SignIn">I already have an account</Link>
        </div>
        <div className="landingTrust"><span>✓ Free to start</span><span>✓ No card required</span><span>✓ Built for curious investors</span></div>

        <div className="landingProduct" aria-label="StockSleuth portfolio preview">
          <div className="landingProductTop"><div className="landingDots"><i /><i /><i /></div><span>Portfolio overview</span><b>Live</b></div>
          <div className="landingProductGrid">
            <div className="landingChartCard">
              <div className="landingMetricLabel">Portfolio value</div>
              <div className="landingMetric">$124,680.40 <small>+18.7%</small></div>
              <svg viewBox="0 0 700 220" preserveAspectRatio="none" role="img" aria-label="Rising portfolio chart">
                <defs><linearGradient id="chartFill" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#7655ef" stopOpacity=".28"/><stop offset="1" stopColor="#7655ef" stopOpacity="0"/></linearGradient></defs>
                <path className="landingArea" d="M0 190 C55 168 75 177 120 145 S190 162 230 127 S300 137 342 96 S415 116 458 76 S530 97 574 50 S645 68 700 18 L700 220 L0 220Z" />
                <path className="landingLine" d="M0 190 C55 168 75 177 120 145 S190 162 230 127 S300 137 342 96 S415 116 458 76 S530 97 574 50 S645 68 700 18" />
              </svg>
              <div className="landingChartDates"><span>Jan</span><span>Mar</span><span>May</span><span>Jul</span><span>Sep</span><span>Now</span></div>
            </div>
            <div className="landingInsightCard">
              <span className="landingSpark">✦</span>
              <div><small>Smart insight</small><strong>Your technology exposure is 8% above target.</strong></div>
              <button type="button">Review allocation →</button>
            </div>
            <div className="landingAllocation"><small>Allocation</small><div className="landingDonut"><span>8</span><small>holdings</small></div><ul><li><i className="violet"/>Technology <b>42%</b></li><li><i className="blue"/>Consumer <b>24%</b></li><li><i className="mint"/>Other <b>34%</b></li></ul></div>
          </div>
        </div>
      </section>

      <div className="landingTape"><div>{[...tickerTape, ...tickerTape].map((ticker, index) => <span key={`${ticker}-${index}`}>{ticker}</span>)}</div></div>

      <section className="landingFeatures">
        <div className="landingSectionIntro"><span>ONE WORKSPACE</span><h2>From question to conviction.</h2><p>Less tab-hopping. More time understanding what you own and why.</p></div>
        <div className="landingFeatureGrid">{features.map((feature, index) => <article key={feature.title} style={{ "--delay": `${index * 120}ms` }}><span>{feature.icon}</span><h3>{feature.title}</h3><p>{feature.text}</p><i>0{index + 1}</i></article>)}</div>
      </section>

      <section className="landingCta"><div><span>YOUR NEXT MOVE, INFORMED</span><h2>Make the market feel<br />a little less noisy.</h2></div><Link to="/SignUp">Create your free account <span>→</span></Link></section>
      <footer className="landingFooter">
        <div className="landingFooterWave" aria-hidden="true" />
        <div className="landingFooterInner"><strong>© 2026 - StockSleuth</strong><Link to="/privacy">Privacy Policy</Link></div>
      </footer>
    </main>
  );
}
